import { Component } from '@angular/core';

@Component({
  selector: 'dx-origence-legal',
  templateUrl: './origence-legal.component.html',
  styleUrls: ['./origence-legal.component.scss']
})
export class OrigenceLegalComponent {
  public print(): void {
    window.print();
  }
}
